// extracted by mini-css-extract-plugin
module.exports = {"row":"Home_row__1rgpe","col":"Home_col__3yanS","thumbnail":"Home_thumbnail__2flgx"};